import requests from "@/utils/request";
import store from "@/store";

let request = requests.request;
let lang = store.state.isLang != "zh-CN" ? "en_en" : "zh_cn";

// 活动列表
export const getActivityList = (params) =>
  request.get("/activities", { lang, params });

// 活动详情
export const getActivityDetail = (id) =>
  request.get(`/activities/${id}`, { lang });

// 报名活动
export const signUpActivity = (id) =>
  request.post(`/activities/${id}/register`, { lang });

// 获取推送信息
export const getPushInfo = () => request.get("/activity/push", { lang });

// 我的活动
export const getMyActivity = (params) =>
  request.get("/my-activities", { lang, params });
